import React from 'react'

import { Checkbox, useFilter } from '@rewardops/ui'

import { handleEnterKeyPress } from '~/utils/event-handler-utils'
import DynamicScrollArea from '~/components/dynamic-scroll-area'

export interface EarnRateOption {
  id: string
  name: string
  key: string
  text: string
}

interface EarnRatesFilterProps {
  options: EarnRateOption[]
  searchEnabled?: boolean
  onSelectionSet?: Function
}

const EarnRatesFilter = ({ options, onSelectionSet }: EarnRatesFilterProps) => {
  const { isEarnRateSelected, addToSelectedEarnRates } = useFilter()

  return (
    <DynamicScrollArea maxHeightClass="h-[40vh]" className="mb-5">
      <div className="flex flex-col gap-3">
        {options?.map((option) => (
          <div
            id={`earn-rate-checkbox-${option.id}`}
            key={option.id}
            role="button"
            tabIndex={0}
            className="flex cursor-pointer items-center space-x-2 font-normal"
            onKeyDown={(e) => {
              handleEnterKeyPress(e, () => addToSelectedEarnRates(option))
              onSelectionSet?.()
            }}
            onClick={(e) => {
              e.preventDefault()
              addToSelectedEarnRates(option)
              onSelectionSet?.()
            }}
          >
            <Checkbox checked={isEarnRateSelected(option.key)} />
            <div className="cursor-pointer">{option.text}</div>
          </div>
        ))}
      </div>
    </DynamicScrollArea>
  )
}

export default EarnRatesFilter
